__turbopack_context__.v({
  "card": "style-module-scss-module__Dj72pq__card",
  "component": "style-module-scss-module__Dj72pq__component",
  "disabled": "style-module-scss-module__Dj72pq__disabled",
  "hide": "style-module-scss-module__Dj72pq__hide",
  "next": "style-module-scss-module__Dj72pq__next",
  "prev": "style-module-scss-module__Dj72pq__prev",
  "thumbnails": "style-module-scss-module__Dj72pq__thumbnails",
});
